<template>
	<div class="basket with-v-gap">
		<h2>{{ basketEntities.length > 0 ? 'Selected Events' : 'No Events'}}</h2>
		<ul>
			<li v-for="entity in basketEntities">
				<div class="whatandwhen">
					<div class="what">{{ entity.name }}</div>
					<div class="when">{{entity | eventDateSummary}} at {{ entity.venueSummary | venueNameAndTown }}</div>
				</div>
				<button class="button close" @click="$emit('remove', entity)"></button>
			</li>
		</ul>
		<div class="buttons">
			<button
				v-if="showAddMoreEventsButton"
				@click="$emit('goToSearch')" class="button">Add {{ basketEntities.length > 0 ? 'more' : ''}} events</button>
			<button
				v-if="basketEntities.length > 0"
				@click="$emit('goToConfigure')"
				class="button gradient sunset">Continue promotion setup</button>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			basketEntities: {
				type: Array,
				required: true
			},
			showAddMoreEventsButton: {
				type : Boolean,
				default : false
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import "../../assets/scss/var";

	.basket {
		border-radius: 20px;
		background     : $color-black;
		margin-left    : $gap-default;
		margin-right   : $gap-default;
		padding        : $gap-large $gap-default $gap-default $gap-default;

		li {
			align-items     : center; // Vert align X with text
			display         : flex;
			justify-content : space-evenly;
			margin-bottom   : $gap-default;

			.whatandwhen {
				flex         : 1;
				margin-left  : $gap-default;
				margin-right : $gap-default;
				max-width    : 500px;
				text-align   : left;
				min-height   : 60px; // Gives basket some height during load

				.what {
					font-size : 1.2rem;
				}
			}

			.close {
				margin-right : $gap-default;
				position     : static;
				width        : 20px;
			}
		}

		.buttons {
			// Stacked on mobile devices
			display         : flex;
			flex-direction  : column;
			justify-content : stretch;

			@media (min-width: 600px) {
				// Adjacent on larger screens
				flex-direction: row;
			}

			.button {
				margin : 10px;
				flex : 1;
			}
		}
	}
</style>
